export default __webpack_public_path__ + "static/media/cluster.c799be88.jpg";